export default function Ccm19PreferencesButton({
  className = 'text-sm hover:underline text-primary',
  children = 'Cookies & Tracking',
}) {
  return (
    <button
      type="button"
      className={className}
      onClick={() => {
        if (typeof window === 'undefined') return;
        window.CCM?.openWidget?.();
      }}
    >
      {children}
    </button>
  );
}
